import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BrianRot from "../Images/Logos/brain.png";
import BrainRotText from "../Images/Logos/brainrot_text.png";
import WorkingHardBrain from "../Images/Brains/working.png";
import IdeaBrain from "../Images/Brains/idea.png";
import TermsOfServicePopup from "../Components/Terms";
import { MdEmail } from "react-icons/md";
import { FaLinkedin, FaDiscord } from "react-icons/fa";

// Typing effect component
const TypingText = ({ phrases, speed = 50, pause = 2000 }) => {
  const [displayedText, setDisplayedText] = useState("");
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [isTyping, setIsTyping] = useState(true);

  useEffect(() => {
    let timeout;

    const currentPhrase = phrases[currentPhraseIndex];

    if (isTyping) {
      if (displayedText.length < currentPhrase.length) {
        timeout = setTimeout(() => {
          setDisplayedText(currentPhrase.slice(0, displayedText.length + 1));
        }, speed);
      } else {
        timeout = setTimeout(() => {
          setIsTyping(false);
        }, pause);
      }
    } else {
      if (displayedText.length > 0) {
        timeout = setTimeout(() => {
          setDisplayedText((prev) => prev.slice(0, -1));
        }, speed / 2);
      } else {
        setIsTyping(true);
        setCurrentPhraseIndex((prev) => (prev + 1) % phrases.length);
      }
    }

    return () => clearTimeout(timeout);
  }, [displayedText, isTyping, currentPhraseIndex, phrases, speed, pause]);

  return (
    <p className="max-w-2xl text-center text-2xl text-gray-900 h-8 min-h-[2rem]">
      {displayedText}
      <span className="animate-pulse">|</span>
    </p>
  );
};

function About() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col pt-16">
      <main className="flex-grow flex flex-col pt-16">
        {/* Hero / Header Section */}
        <div className="container mx-auto flex flex-col items-center justify-center gap-8 px-4 py-8">
          {/* Logo */}
          <div className="flex flex-col items-center">
            <img
              src={BrianRot}
              alt="brAIn rot logo"
              className="w-24 h-24 lg:w-36 lg:h-36 mb-4"
            />
            <img
              src={BrainRotText}
              alt="brAIn rot text logo"
              className="w-auto h-12 lg:h-24"
            />
          </div>

          {/* Typing Tagline */}
          <TypingText
            phrases={[
              "coding contests on games 😎",
              "practice algorithms & ML skills 🧠",
              "climb the leaderboard & win prizes 🏆",
              "showcase your code to the world 🌍",
              "launch your AI bots into live battles 🤖",
              "sponsor contests for outreach 📢",
            ]}
          />

          {/* Call-to-Action Buttons */}
          <div className="flex flex-col md:flex-row gap-6 text-2xl w-full max-w-2xl pt-2">
            <button
              onClick={() => navigate("/games")}
              className="hover:bg-pink-100 bg-white w-full flex flex-row px-8 py-6 font-semibold justify-center items-center text-center rounded-2xl shadow-lg hover:shadow-xl transition-transform transform hover:scale-105 border-2 border-primary gap-6"
            >
              <img
                src={WorkingHardBrain}
                alt="Working Hard Brain"
                className="h-10 mb-2"
              />
              <div className="flex flex-col">
                <div className="text-3xl">compete</div>
                <div className="text-sm italic mt-1">for developers</div>
              </div>
            </button>

            <button
              onClick={() => navigate("/sponsor")}
              className="hover:bg-pink-100 bg-white w-full flex flex-row px-8 py-6 font-semibold justify-center items-center text-center rounded-2xl shadow-lg hover:shadow-xl transition-transform transform hover:scale-105 border-2 border-primary gap-6"
            >
              <div className="flex flex-col">
                <div className="text-3xl">support</div>
                <div className="text-sm italic mt-1">for sponsors</div>
              </div>
              <img src={IdeaBrain} alt="Idea Brain" className="h-12 mb-2" />
            </button>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="w-full mt-6 py-6">
        <div className="container mx-auto text-center">
          <div className="flex justify-center mb-4">
            <a
              href="https://www.linkedin.com/company/brain-rot-code"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 hover:underline mx-2"
            >
              <FaLinkedin className="text-xl text-primary" />
              <p className="hidden sm:block">LinkedIn</p>
            </a>

            <a
              href="mailto:brainrot4ai@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 hover:underline mx-2"
            >
              <MdEmail className="text-xl text-primary" />
              <p className="hidden sm:block">Email</p>
            </a>

            <a
              href="https://discord.gg/atjYvGbdrK"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 hover:underline mx-2"
            >
              <FaDiscord className="text-xl text-primary" />
              <p className="hidden sm:block">Discord</p>
            </a>

            <div className="flex items-center gap-2 hover:underline mx-2">
              <TermsOfServicePopup />
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default About;
